import { DollarSign, Truck, Users } from "lucide-react";
import { CheckoutListItem } from "../../../../api/services/checkoutService";
import { Card, CardContent } from "../../../../components/ui/card";
import { StatBox } from "../../../../components/ui/stat-box";
import { useCheckoutActions } from "../../hooks/useCheckoutActions";
import { CheckoutActionButtons } from "../../pages/entrego-resolution/components/checkout-action-buttons";

interface CheckoutOperationCardProps {
  item: CheckoutListItem;
  dbName: string;
  onRefresh?: () => void;
}

export function CheckoutOperationCard({
  item,
  dbName,
  onRefresh,
}: CheckoutOperationCardProps) {
  const uniqueDrivers =
    item.entregadores_unicos_cadastrados || item.entregadores_unicos || 0;

  const {
    confirmCheckout,
    startDoc,
    submitRemessa,
    isConfirming,
    isStartingDoc,
    isSubmittingRemessa,
  } = useCheckoutActions(onRefresh);

  const dateCheckout = item.date_to_checkout.slice(0, 10);
  const displayDate = dateCheckout.split("-").reverse().join("/");

  return (
    <div className="mb-8">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold">{displayDate}</h3>
        <CheckoutActionButtons
          status={item.status}
          ops={item.ops}
          date={dateCheckout}
          onConfirmCheckout={() =>
            confirmCheckout({
              dbName,
              filterDate: dateCheckout,
              ops: item.ops,
            })
          }
          onStartDoc={() =>
            startDoc({
              dbName,
              filterDate: dateCheckout,
              ops: item.ops,
            })
          }
          onSubmitRemessa={() =>
            submitRemessa({
              dbName,
              filterDate: dateCheckout,
              ops: item.ops,
            })
          }
          isConfirming={isConfirming}
          isStartingDoc={isStartingDoc}
          isSubmittingRemessa={isSubmittingRemessa}
        />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        <Card className="min-h-[140px]">
          <CardContent className="p-6 flex flex-col justify-between h-full">
            <div className="flex items-start justify-between">
              <div className="flex-1">
                <p className="text-sm font-medium text-muted-foreground mb-2">
                  Operação
                </p>
                <p className="text-2xl font-bold text-foreground uppercase">
                  {item.ops}
                </p>
              </div>
              <div className="ml-4 flex-shrink-0">
                <Truck className="h-6 w-6 text-primary" />
              </div>
            </div>
          </CardContent>
        </Card>

        <StatBox
          title="MB únicos"
          value={uniqueDrivers}
          valueType="integer"
          icon={<Users className="h-6 w-6 text-primary" />}
        />

        <StatBox
          title="Ticket Médio"
          value={item.ticket_medio}
          valueType="cents"
          icon={<Truck className="h-6 w-6 text-primary" />}
        />

        <StatBox
          title="Valor de face acumulado"
          value={item.total_valor_face}
          valueType="cents"
          icon={<DollarSign className="h-6 w-6 text-primary" />}
        />
      </div>
    </div>
  );
}
